import { atom, selector } from "recoil";
import { Service_GL } from "../utils/CommonFunc";

//// 유저 정보
export const connectSiteState = atom<string>({
  key: "connectSiteState",
  default: "vfun"
});

// export const loginState = atom<boolean>({
//   key: "loginState",
//   default: false
// });

export const userIdState = atom<string>({
  key: "userIdState",
  default: "none"
});

export const ssoinfoState = atom<string>({
  key: "ssoinfoState",
  default: "none"
});

export const juminState = atom<string>({
  key: "juminState",
  default: "none"
});

export const userNicknameState = atom<string>({
  key: "userNicknameState",
  default: ""
});

export const adminState = atom<boolean>({
  key: "adminState",
  default: false
});

export const userBirthState = atom<string>({
  key: "userBirthState",
  default: "none"
});

export interface userInfoProps {
  Ssoinfo: string;
  Userid: string;
  Userbirth: string;
  channelingType: string;
}

export const userInfoState = selector<userInfoProps>({
  key: "userInfoState",
  get: ({ get }) => {
    const ssoinfo = get(ssoinfoState);
    const userId = get(userIdState);
    const userBirth = get(userBirthState);
    const jumin = get(juminState);
    const connectSite = get(connectSiteState);

    const info = {
      Ssoinfo: ssoinfo,
      Userid: userId,
      Userbirth: Service_GL ? userBirth : jumin,
      channelingType: connectSite
    };
    return info;
  }
});

//// UI atom 요소
export const menuOpenState = atom<boolean>({
  key: "menuOpenState",
  default: false
});

export const agePopState = atom<boolean>({
  key: "agePopState",
  default: false
});

export const isMobileMatcheState = atom<boolean>({
  key: "isMobileMatcheState",
  default: false
});

export const isOpenShareState = atom<boolean>({
  key: "isOpenShareState",
  default: false
});

export const searchState = atom<string>({
  key: "searchState",
  default: ""
});

export const visibleState = atom<boolean>({
  key: "visibleState",
  default: true
});

export const isDeleteLoadingState = atom<boolean>({
  key: "isDeleteLoadingState",
  default: false
});

export const youtubeIdState = atom<null | string>({
  key: "youtubeIdState",
  default: null
});

export const viewTypeState = atom<string>({
  key: "viewTypeState",
  default: ""
});

export const isShowBannerState = atom<boolean>({
  key: "isShowBannerState",
  default: false
});

// PopPage 요소
export const popState = atom<boolean>({
  key: "popState",
  default: false
});

export const cameraToggleState = atom<boolean>({
  key: "cameraToggleState",
  default: false
});

export const isOpenEmojiState = atom<boolean>({
  key: "isOpenEmojiState",
  default: false
});

export const imgBase64State = atom<string[]>({
  key: "imgBase64State",
  default: []
});

export const imgFileState = atom<FileList | null>({
  key: "imgFileState",
  default: null,
  dangerouslyAllowMutability: true
});

//// 언어
export const langState = atom<string>({
  key: "langState",
  default: "English"
});

export const langCodeState = atom<string>({
  key: "langCodeState",
  default: "en"
});

interface LangList {
  lang: string;
  lang_code: string;
}

export const langListState = atom<LangList[]>({
  key: "langListState",
  default: []
});

//// contents 관련 요소
export const textState = atom<string>({
  key: "textState",
  default: ""
});

export const contentsValueState = atom<string>({
  key: "contentsValueState",
  default: ""
});

export const titleValueState = atom<string>({
  key: "titleValueState",
  default: ""
});

export const writingTypeState = atom<string>({
  key: "writingTypeState",
  default: ""
});

export const likeCountState = atom<number>({
  key: "likeCountState",
  default: 0
});

export const userBoardLikeState = atom<boolean>({
  key: "userBoardLikeState",
  default: false
});

export const isLikeLoadingState = atom<boolean>({
  key: "isLikeLoadingState",
  default: false
});

export const parentsIdxState = atom<number>({
  key: "parentsIdxState",
  default: 0
});

export const isEditState = atom<boolean>({
  key: "isEditState",
  default: false
});

export const editContentNumState = atom<number>({
  key: "editContentNumState",
  default: 0
});

export const editCommentNumState = atom<number>({
  key: "editCommentNumState",
  default: 0
});

export const ShareArticleToggle = atom<object>({
  key: "ShareArticleToggle",
  default: {}
});

export const snsListState = atom<string>({
  key: "snsListState",
  default: ""
});

export const isThroughMainState = atom<boolean>({
  key: "isThroughMainState",
  default: false
});

export const isDetailState = atom<boolean>({
  key: "isDetailState",
  default: false
});

export const isUserRightsState = atom<any[]>({
  key: "isUserRightsState",
  default: []
});

//// 네이버
export const isPrivacyAgreeState = atom<boolean>({
  key: "isPrivacyAgreeState",
  default: false
});

export const naverAuthorizeUrl = atom<string>({
  key: "naverAuthorizeUrl",
  default: ""
});
